import * as React from "react";
import { useStaticQuery, graphql } from "gatsby";

//Slides
import Ventilation_1 from "../../images/DuctedVent.jpg";
import Ventilation_2 from "../../images/Vent Construction.jpg";

import SlideShow from "../../components/slider";
import GradientHero from "../../components/gradientHero";

import HorizontalIcons from "../../components/horizontal-icons";
import Layout from "../../components/layout";

const Ventilation = ({ pageContext }) => {
  const wpdata = useStaticQuery(graphql`
    {
      wp {
        page(id: "commercial/ventilation", idType: URI) {
          commercialVentilation {
            csHeader
            ctaHeader
            heroBackgroundColor
            heroContent
            heroHeading
            summaryContent
            heroLink {
              target
              title
              url
            }
            heroImage {
              altText
              sourceUrl
            }
            csRepeater {
              toggle
              content
              header
              image {
                altText
                sourceUrl
              }
            }
            ctaLinkOne: ctaLink1 {
              target
              title
              url
            }
            ctaLinkTwo: ctaLink2 {
              target
              title
              url
            }
            featuresItemsOne: featuresItems1 {
              heading
              image {
                altText
                sourceUrl
              }
            }
            featuresItemsTwo: featuresItems2 {
              heading
              image {
                altText
                sourceUrl
              }
            }
          }
        }
      }
    }
  `);
  const data = wpdata?.wp?.page?.commercialVentilation || {};

  return (
    <Layout pageContext={pageContext}>
      <GradientHero image={data?.heroImage?.sourceUrl}>
        <h5>{data?.heroHeading}</h5>

        <p dangerouslySetInnerHTML={{ __html: data?.heroContent }}></p>
        <a href={data?.heroLink?.url} target={data?.heroLink?.target}>
          {data?.heroLink?.title}
        </a>
      </GradientHero>

      <div className="bg-black">
        <div className="max-w-6xl text-center mx-5 md:mx-20 lg:mx-auto py-20">
          <p
            className="text-xl text-white mb-10"
            dangerouslySetInnerHTML={{ __html: data?.summaryContent }}
          ></p>
        </div>
      </div>

      <div>
        <HorizontalIcons
          icons={data?.featuresItemsOne?.map((v) => ({
            text: v?.heading,
            image: v?.image?.sourceUrl,
          }))}
        />

        <div className="max-w-7xl text-center mx-auto pt-3 pb-32">
          <a
            className="mt-30 bg-tan text-2xl text-black uppercase font-anton px-16 py-3"
            href={data?.ctaLinkOne?.url}
            target={data?.ctaLinkOne?.target}
          >
            {data?.ctaLinkOne?.title}
          </a>
        </div>
      </div>

      <div style={{ backgroundColor: "#F8F8F8" }}>
        <HorizontalIcons
          icons={data?.featuresItemsTwo?.map((v) => ({
            text: v?.heading,
            image: v?.image?.sourceUrl,
          }))}
        />

        <div className="max-w-7xl text-center mx-auto pt-3 pb-32">
          <h3 className="text-black text-center text-3xl mb-10">
            {data?.ctaHeader}
          </h3>
          <a
            className="mt-30 bg-tan text-2xl text-black uppercase font-anton px-16 py-3"
            href={data?.ctaLinkTwo?.url}
            target={data?.ctaLinkTwo?.target}
          >
            {data?.ctaLinkTwo?.title}
          </a>
        </div>
      </div>

      {!!data?.csRepeater?.filter((x) => x?.toggle)?.length && (
        <div className="mb-24 case-studies">
          <h3 className="text-black text-4xl text-center my-16">
            {data?.csHeader}
          </h3>
          {data?.csRepeater
            ?.filter((x) => x?.toggle)
            ?.map((v, i) => (
              <div
                key={i}
                className="flex flex-wrap lg:flex-nowrap max-w-6xl mx-5 md:mx-20 lg:mx-auto mb-10"
              >
                <div className="w-full lg:w-1/2 ">
                  <div
                    className="h-80 bg-tan bg-img"
                    style={{ backgroundImage: `url(${v?.image?.sourceUrl})` }}
                  ></div>
                </div>
                <div className="ml-5 w-full lg:w-1/2">
                  <h3 className="text-black text-xl">{v?.header}</h3>
                  <p>{v?.content}</p>
                </div>
              </div>
            ))}
        </div>
      )}
    </Layout>
  );
};

export default Ventilation;
